export default "__VITE_ASSET__87b3a029__"